<template>
    <div>
    </div>
</template>
<script>
export default {
     data() {
        return {

        }
     },
    methods(){

    },
    created() {

    },
    mounted() {

    }
}
</script>
<style lang="css" scoped>

</style>